module.exports = __webpack_public_path__ + "static/flags/ET-35d7c73c95a00e80eaedef7a2a8baefa.gif";